<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">セクション追加</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area">

        <div class="column-list" (dragstart)="onDragstartBody($event)">
          <div class="list-input-title">セクション名</div>
          <div class="list-input-content">
            <app-not-null-text-input class="text-label-required" id="txti_SectionName" [subid]="'txti_SectionName'" style="width:27rem;"
              [displayCountField]="false" [restrict]="'[ -￮]'" [maxChars]="25" [(ngModel)]="sectionName" [tabindex]="0">
            </app-not-null-text-input>
          </div>
          <div class="list-input-title">グリッド</div>
          <div class="list-input-content">
            <label>横</label>
            <wj-input-number [step]="1" class="numeric-stepper" id="ns_SectionDivW" [min]="1" [max]="99"
              [(ngModel)]="sectionDivW" [tabindex]="0" format="n0">
            </wj-input-number>
            <label>×</label>
            <label>縦</label>
            <wj-input-number [step]="1" class="numeric-stepper" id="ns_SectionDivH" [min]="1" [max]="99"
              [(ngModel)]="sectionDivH" [tabindex]="0" format="n0">
            </wj-input-number>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" (click)="eventCreateHandler()" [tabindex]="0">作成</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventCloseHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>